import React from "react";
import { StyleSheet, TouchableOpacity } from "react-native";

import Svg, { Path, G } from "react-native-svg";

const CloseIcon = ({ onPress, style, color = "#2D3142", opacity = 0.2 }) => {
  return (
    <TouchableOpacity
      onPress={(e) => {
        if (onPress) onPress(e);
      }}
      style={[styles.closeButton, style]}
    >
      <Svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <G opacity={opacity}>
          <Path
            d="M10.8309 5.80903C10.7308 5.70872 10.5949 5.65234 10.4533 5.65234C10.3116 5.65234 10.1757 5.70872 10.0757 5.80903L8.31993 7.56583L6.56419 5.80903C6.35565 5.60049 6.01754 5.60049 5.80899 5.80903C5.60045 6.01757 5.60045 6.35569 5.80899 6.56423L7.56579 8.31996L5.80899 10.0757C5.60045 10.2842 5.60045 10.6224 5.80899 10.8309C6.01754 11.0394 6.35565 11.0394 6.56419 10.8309L8.31993 9.0741L10.0757 10.8309C10.2106 10.9658 10.4072 11.0185 10.5915 10.9691C10.7758 10.9197 10.9197 10.7758 10.9691 10.5915C11.0185 10.4072 10.9658 10.2106 10.8309 10.0757L9.07406 8.31996L10.8309 6.56423C10.9312 6.46417 10.9875 6.32831 10.9875 6.18663C10.9875 6.04495 10.9312 5.90909 10.8309 5.80903Z"
            fill={color}
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.91992 8.31992C1.91992 4.7853 4.7853 1.91992 8.31992 1.91992C11.8531 1.92345 14.7164 4.78676 14.7199 8.31992C14.7199 11.8545 11.8545 14.7199 8.31992 14.7199C4.7853 14.7199 1.91992 11.8545 1.91992 8.31992ZM2.98659 8.3201C2.98659 11.2656 5.3744 13.6534 8.31992 13.6534C9.73441 13.6534 11.091 13.0915 12.0912 12.0913C13.0913 11.0911 13.6533 9.73458 13.6533 8.3201C13.6533 5.37458 11.2654 2.98676 8.31992 2.98676C5.3744 2.98676 2.98659 5.37458 2.98659 8.3201Z"
            fill={color}
          />
        </G>
      </Svg>
    </TouchableOpacity>
  );
};

export default CloseIcon;

const styles = StyleSheet.create({
  closeButton: {
    position: "absolute",
    right: 6,
    top: 6,
    zIndex: 3,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
});
